export const PAGE_SIZE_OPTIONS = [25, 50, 100] as const;
export type PageSize = typeof PAGE_SIZE_OPTIONS[number];

/** Convert a page number + page size to an API offset. */
export const pageToOffset = (page: number, pageSize: number): number =>
  (page - 1) * pageSize;

/** Derive total pages from a total item count and page size. */
export const calcTotalPages = (totalCount: number, pageSize: number): number =>
  Math.max(1, Math.ceil(totalCount / pageSize));
